var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "search_svg__cls-1",
    d: "M16.47 33.13a16.575 16.575 0 1 1 16.47-16.57 16.538 16.538 0 0 1-16.47 16.57Zm0-31.75a15.18 15.18 0 1 0 15.09 15.18A15.144 15.144 0 0 0 16.47 1.38Zm18.51 35.61-8.61-9.48 1.02-.94L36 36.04Z"
  })));
};
export default SvgSearch;